import React from 'react'
import GridItem from './GridItem'
import ListItem from './ListItem'
import _ from 'lodash'
import { axios } from '~/axios'
import Spinner from '~/components/Spinner'
import { differenceInCalendarDays,format } from "date-fns";
import { CalendarIcon } from '~/assets/svg'
import Modal from '~/components/Modal'
import Calendar from '~/components/Calendar'
import enhanceWithClickOutside from 'react-click-outside';
import './styles.css'

const DISPLAY_COUNT = 6

class Events extends React.Component {
	constructor(){
		super()

		const currentDate = new Date()

		this.state = {
			currentView: "grid",
			events: [],
			year: currentDate.getFullYear(),
			month: currentDate.getMonth(),
			date: currentDate.getDate(),
      currentType: 'All Events',
      currentOffset: DISPLAY_COUNT,
			noEventsTimer: 0,
			isModelOpen: false
		}
	
		this.viewChange = this.viewChange.bind(this)
		this.typeChange = this.typeChange.bind(this)
		this.getEvents = this.getEvents.bind(this)
    this.filterEvents = this.filterEvents.bind(this)
		this.loadMore = this.loadMore.bind(this)
		this.showModal = this.showModal.bind(this)
  }
  
  viewChange(e){
		this.setState({
			currentView: e.target.value,
		})
	}

	typeChange(e){
		this.setState({
			currentType: e.target.value
		})
	}

	bodyHack(shown) {
		const bcl = window.document.body.classList
		if (bcl && shown) {
			bcl.add('overflow-hide')
		} else if (bcl && bcl.contains('overflow-hide')) {
			bcl.remove('overflow-hide')
		}
	}

	showModal() {
		this.bodyHack(!this.state.isModelOpen)
		this.setState({ isModelOpen: !this.state.isModelOpen })
	}


	componentDidMount(){
		this.getEvents(this.state.year, this.state.month)
	}

	componentDidUpdate(prevProps, prevState){
		let focusableEvents = this.eventsCtner.firstChild.children
		let	eventIdxToFocus = prevState.currentOffset - 1

		if (prevState.currentOffset !== this.state.currentOffset) {
			if (focusableEvents[eventIdxToFocus]) {
				this.focusNextLoadedEvent()
			}
		} else if (prevState.events.length !== this.state.events.length) {
			this.focusNextLoadedEvent()
		}
	}

	focusNextLoadedEvent() {
		if (this.firstEventLoad !== false) 
			return

		let focusableEvents = this.eventsCtner.firstChild.children
		let	eventIdxToFocus = this.state.currentOffset - DISPLAY_COUNT
		focusableEvents[eventIdxToFocus].focus()
	}

	gotoEvent(e) {
		e.preventDefault()
		const current = e.currentTarget;
		if(current.dataset.url){
			window.location.href = current.dataset.url
			return;
		}
  }
  
  loadMore(){
		this.handleEventLoadState()

		if (this.state.currentOffset + DISPLAY_COUNT > this.state.events.length)
			this.getEvents(this.state.year + 1, this.state.month + 1)

		this.setState({ currentOffset: this.state.currentOffset + DISPLAY_COUNT })
	}

	getEvents(year, month){
    if(this.state.events[`${month}/${year}`])
			return

		this.setState({ loading: true })
    
		const fromDate = Math.floor(new Date(year, month, 1).getTime() / 1000)			// getting events for one year example: it this is march(2018) getting events from march 2018 to march 2019
		const toDate = Math.floor(new Date(year + 1, month + 1, 0).getTime() / 1000)

		axios.get(`/content/event/schedule`, {
			params: {
				from: fromDate,
				to: toDate
			}
		}).then(response => {
			this.handleEventLoadState()

      this.setState({
        events: this.state.events.concat(this.filterEvents(response.data)),
				loading: false,
				noMoreEvents: (response.data.length === 0)
      })
    }).catch(err => {
			console.log(err)
		})
	}
	
	handleEventLoadState() {
		if (this.firstEventLoad === undefined) {
			this.firstEventLoad = true
		} else if (this.firstEventLoad) {
			this.firstEventLoad = false
		}
	}
  
  filterEvents(events){
    let filteredEvents = []
		_.map(events, event => {
      _.map(event.gist.eventSchedule, schedule => {
        var current = {};
				current.scheduleDate = schedule.eventDate * 1000 //+ new Date(schedule.eventDate * 1000).getTimezoneOffset() * 60 * 1000
				current.eventTime = schedule.eventTime * 1000 //+ new Date(schedule.eventTime * 1000).getTimezoneOffset() * 60 * 1000
				if(schedule.doorTime){
					current.doorTime = schedule.doorTime * 1000 //+ new Date(schedule.doorTime * 1000).getTimezoneOffset() * 60  * 1000
				}
        current.id = event.gist.id + current.scheduleDate;
        
        if (differenceInCalendarDays(format(current.scheduleDate, 'MM/DD/YYYY'), format(Date.now(),'MM/DD/YYYY')) >= 0) {
					let newCurrentDate = new Date(current.scheduleDate)
          current.date = newCurrentDate.getDate();
          current.year = newCurrentDate.getFullYear();
          current.month = newCurrentDate.getMonth();
          current.schedule = schedule;
          current.gist = event.gist;
          filteredEvents.push(current);
        }
      });
    })
    filteredEvents = _.uniqBy(filteredEvents, "id")
    filteredEvents = _.sortBy(filteredEvents, "scheduleDate")
    return filteredEvents
  }

	handleClickOutside(){
		this.setState({
			eventPopup: false
		})
	}

	render(){
    let eventTypes = ["All Events"]
		const metadata = this.props.data && this.props.data.metadataMap 
		const allEventsLink = metadata && metadata.viewALLEventsURL;
		const stanzaHandle = metadata && metadata.stanzaHandle;
    this.state.events.forEach(event => {
			eventTypes.push(event.gist.type)
		})
      
    eventTypes = eventTypes.sort().filter((type,index)=>{ // getting unique values
			return (type !== eventTypes[index + 1] )
    })
		
		let showEvents = this.state.events.filter(event =>{
      return (this.state.currentType === event.gist.type || this.state.currentType === "All Events")
		})

		showEvents = showEvents.slice(0, this.state.currentOffset)
		return(
			<div className="events-box-shadow">
				<div className="events-container">
					<div className="events-header">
						<div tabIndex="0" aria-label="Upcoming events" className="events-copy">Upcoming Events</div>
						<div className="event-selectors">
							{ stanzaHandle && 
								<button aria-label="Add to Calendar" className="add-to-calendar" onClick={() => this.showModal()}>
									<div className="add-calendar"><CalendarIcon/><span>Add to Calendar</span> </div>
								</button> }
							<div className="event-type-selectors">
								<select role="combobox" aria-label="Select event type" className="event-type-select" onChange={e => this.typeChange(e)}>
									{eventTypes.map((type, index) =>{
										return <option value={type} key={index}>{type}</option>
									})
									}
								</select>
								<ion role="presentation" className="ion-ios-arrow-down" />
							</div>
							<div className="event-view-selectors">
								<div className="icon-view">
									{ !(this.state.currentView === "list") 
										? <ion role="presentation" className={`ion-${this.state.currentView}`} /> 
										: <ion role="presentation" className={`ion-ios-list`} />
									}
								</div>
								<select 
									role="combobox"
									aria-label="Select event viewing style" 
									className="event-view-select" 
									onChange={ e =>this.viewChange(e)}
								>
									<option value="grid">Grid</option>
									<option value="list">List</option>
									<option value="calendar">Calendar</option>
								</select>
								<ion role="presentation" className="ion-ios-arrow-down" />
							</div>
						</div>
					</div>
					<div ref={ el => this.eventsCtner = el } className="events-view">
						{this.state.currentView === "grid" && <div className="grid-view">
							{
								showEvents.map(event => { return <GridItem event={event} key={event.id} gotoEvent={this.gotoEvent}/>} )
							}
						</div>}
						{this.state.currentView === "list" && <div className="list-view">
							{
								showEvents.map(event => { return <ListItem event={event} key={event.id} gotoEvent={this.gotoEvent}/> })
							}
						</div>}
						{this.state.currentView === "calendar" && <Calendar type={this.state.currentType} gotoEvent={this.gotoEvent}/>}
				
					</div>
					{!(this.state.currentView === "calendar") && this.state.loading && <Spinner />}

					{ this.state.currentView !== "calendar" && 
						<div className="load-more">
							{ allEventsLink 
								? <a aria-label="View all events" href={allEventsLink} className="view-all"> View All </a> 
								: (
										this.state.events.length > DISPLAY_COUNT ?
											<button 
												aria-label="Load more events"
												className={`load-more-button` + (this.state.noMoreEvents ? ' no-events': '')} 
												onClick={ this.loadMore }>
												Load More 
											</button> :
											<div/>
									)
							}
						</div>
					}
					
					{ this.state.isModelOpen && <Modal
						title='Add to Calendar'
						shown={this.state.isModelOpen}
						closeModal={this.showModal}
						className="modal-anim calendar-iframe"
						children={
							<iframe src={`https://stanza.co/@${stanzaHandle}?embed=true`}></iframe>
						}
					/>}
				</div>
			</div>
		)
	}
}

export default enhanceWithClickOutside(Events)